(() => {
  'use strict';
  const tr=(key,values={})=>String(window.Q21Messages?.[key] ?? '').replace(/&amp;/g,'&').replace(/&quot;/g,'"').replace(/&#39;|&apos;/g,"'").replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/__q21_(\d+)__/g,(_,k)=>String(values['p'+k]??''));
  window.Q21BackendFinder?.dispose();
  const lifecycle = new AbortController(), instances = new Map();
  const keys = ['series', 'development_code', 'model', 'engine'];
  const hiddenSeries = new Set(['-', 'C', 'E', 'F', 'G', 'H', 'K', 'R', 'S']);
  const text = (value, max = 300) => typeof value === 'string' && value.length <= max && !/[\u0000-\u0008\u000b\u000c\u000e-\u001f]/.test(value);
  const validKey = value => typeof value === 'string' && /^[a-zA-Z0-9_/-]{1,40}$/.test(value);
  const validProfile = p => p && validKey(p.type_key) && ['development_code','model','engine','body','gearbox','market'].every(k => p[k] == null || text(p[k]));
  const gearboxLabel = value => ({MECH:tr("text_kvjkpd"),AUT:tr("text_ot597w"),MANUAL:tr("text_kvjkpd"),AUTO:tr("text_ot597w")})[value] || value || tr("text_998y6u");
  const label = p => [p.development_code,p.model,p.engine,gearboxLabel(p.gearbox),p.market].filter(Boolean).join(' / ');
  const element = (tag, value, className) => { const el = document.createElement(tag); if (value !== undefined) el.textContent = value; if (className) el.className = className; return el; };
  const moduleTitle = value => value.normalize('NFKC').toLocaleLowerCase('de-DE').replace(/^module?\s*[-–—:]\s*/, '').replace(/\s+/g, ' ').trim();

  function mount(root) {
    if (instances.has(root)) return;
    const $ = selector => root.querySelector(selector);
    const selects = keys.map(key => $(`select[data-key="${key}"]`));
    const status = $('[data-status]'), profiles = $('[data-profiles]'), panel = $('[data-offer-panel]');
    const input = $('[data-vin-input]'), submit = $('[data-vin-form] button'), retry = $('[data-retry]');
    if (selects.some(s => !s) || !status || !profiles || !panel || !input || !submit || !retry) return;
    const productLayer = window.Q21ProductLayer?.mount(root);
    // Optional visual enhancement: any failure is isolated from the buying flow.
    let performanceCard=null;
    try { performanceCard=window.Q21FinderPerformance?.mount(root); } catch (_) { /* keep original intro */ }
    function performanceAction(method,context){
      try { return performanceCard?.[method]?.(context); } catch (_) { return false; }
    }
    // Flash licences come only from the API. Configured Shopify modules are also
    // shown for every confirmed vehicle as a catalog overview, not an API release claim.
    const moduleCatalog = new Map();
    root.querySelectorAll('[data-store-item]').forEach(card => {
      if (!text(card.dataset.productTitle) || !card.dataset.moduleKey || card.dataset.moduleKey === 'none') return;
      const title = moduleTitle(card.dataset.productCanonicalTitle || card.dataset.productTitle);
      moduleCatalog.set(title, moduleCatalog.has(title) ? null : card);
    });
    const events = new AbortController();
    let active, revision = 0, disposed = false, lastAction, method = 'car';
    const vehicleMemory=window.Q21VehicleMemory;
    let restoringVehicle=null;
    const path = (root.dataset.proxy || '').trim();
    const validPath = /^\/apps\/[a-zA-Z0-9_-]+(?:\/[a-zA-Z0-9_-]+)*$/.test(path);
    const current = version => !disposed && version === revision;
    const on = (el, type, callback) => el.addEventListener(type, callback, {signal: events.signal});
    // Presentation only. Requests, approval checks, prices and product-layer purchase handlers are untouched.
    const mobile = window.matchMedia('(max-width: 700px)');
    const english = root.ownerDocument.documentElement.lang.startsWith('en');
    const pathUi = element('div', undefined, 'q21-mobile-path');
    pathUi.setAttribute('aria-label', english ? 'Selected vehicle details' : 'Gewählte Fahrzeugdaten');
    selects[0].closest('.q21-select-grid').before(pathUi);
    const help = element('button', english ? 'Getting started & licence guide' : 'Einstieg & Lizenzvergleich', 'q21-mobile-help');
    help.type='button'; help.setAttribute('aria-expanded','false');
    help.setAttribute('aria-controls', root.querySelector('[data-q21-focus]')?.id || 'so-funktionierts');
    panel.prepend(help);
    const mobileGroups=[];
    function syncMobile(){
      const buying=mobile.matches&&!panel.hidden;
      root.classList.toggle('q21-mobile-buying',buying);
      if(!buying){root.classList.remove('q21-mobile-help-open');help.setAttribute('aria-expanded','false');}
      const next=selects.findIndex(select=>!select.value);
      selects.forEach((select,index)=>select.parentElement.classList.toggle('q21-mobile-field-hidden',mobile.matches&&index!==next));
      pathUi.replaceChildren();
      selects.forEach((select,index)=>{
        if(!select.value)return;
        const button=element('button',select.selectedOptions[0]?.textContent || select.value);button.type='button';
        const label=select.parentElement.querySelector('label')?.textContent.trim() || select.dataset.key;
        button.setAttribute('aria-label',(english?'Change ':'Ändern: ')+label+' · '+button.textContent);
        on(button,'click',()=>{select.value='';clearAfter(index);loadOptions();});pathUi.append(button);
      });
      pathUi.hidden=!mobile.matches||!pathUi.childElementCount;
      mobileGroups.forEach(({details,article})=>{
        if(mobile.matches){
          details.hidden=false;
          if(article.parentNode!==details)details.append(article);
          if(details.dataset.wasDesktop==='true')details.open=false;
        }else{
          // Direct grid children on desktop: native details-content wrappers must
          // never determine the height of a peer product card.
          if(article.parentNode===details)details.before(article);
          details.hidden=true;details.open=true;
        }
        details.dataset.wasDesktop=String(!mobile.matches);
      });
    }
    function decorateOfferUi(target){
      mobileGroups.length=0;
      target.style.setProperty('--q21-offer-columns',String(Math.min(4,target.querySelectorAll('.q21-backend-offer').length)||1));
      target.querySelectorAll('.q21-backend-offer').forEach(article=>{
        if(!['single','custom'].includes(article.dataset.offerKind))return;
        const details=element('details',undefined,'q21-license-collapse');
        const summary=element('summary');
        const heading=element('span',article.dataset.offerKind==='single'?'Single Option':'Custom Tune','q21-license-summary-title');
        const note=element('small',article.dataset.offerKind==='single'?(english?'Sold separately · included with OTS':'Einzeln erhältlich · bei OTS inklusive'):(english?'For modified hardware · OTS add-on':'Bei Hardware-Umbau · OTS-Add-on'));
        const left=element('span');left.append(heading,note);summary.append(left);
        const price=article.querySelector('.q21-offer-price>strong');if(price)summary.append(element('strong',price.textContent));
        summary.append(element('span','⌄','q21-license-summary-chevron'));details.append(summary);
        article.before(details);details.append(article);details.open=!mobile.matches;details.dataset.wasDesktop=String(!mobile.matches);mobileGroups.push({details,article});
      });
      const title=panel.querySelector('.license-heading h2');if(title)title.textContent=english?'Your options.':'Deine Möglichkeiten.';
      const intro=panel.querySelector('.catalog-intro');if(intro)intro.textContent=english?'More power or individual functions. Your choice.':'Mehr Leistung oder einzelne Funktionen. Du entscheidest.';
      syncMobile();
    }
    on(help,'click',()=>{
      const open=root.classList.toggle('q21-mobile-help-open');help.setAttribute('aria-expanded',String(open));
      if(open)root.querySelector('[data-q21-focus]')?.scrollIntoView({block:'start',behavior:'auto'});
    });
    on(mobile,'change',syncMobile);


    function message(value, error = false) { status.textContent = value; status.dataset.error = String(error); }
    function clearVin() { input.value = ''; $('[data-vin-count]').textContent = '0 / 17'; input.removeAttribute('aria-invalid'); }
    function invalidate() {
      revision++; active?.abort(); active = undefined;
      performanceAction('reset');
      productLayer?.close();
      profiles.replaceChildren(); panel.hidden = true; $('[data-offers]').replaceChildren();
      window.Q21StoreMotion?.refresh?.();
      $('[data-vehicle]').textContent = ''; retry.hidden = true; submit.disabled = !validPath;
      root.removeAttribute('aria-busy'); syncMobile();
    }
    function criteria() { return Object.fromEntries(selects.filter(s => s.value).map(s => [s.dataset.key, s.value])); }
    function enableSelects() { selects.forEach((s, i) => { s.disabled = !validPath || s.options.length < 2 || selects.slice(0, i).some(previous => !previous.value); }); syncMobile(); }
    function clearAfter(index) { selects.slice(index + 1).forEach(s => { s.replaceChildren(new Option(tr("text_ps4gkk"), '')); s.disabled = true; }); }
    async function request(endpoint, body) {
      if (!validPath) throw new Error('config');
      active?.abort(); const controller = new AbortController(); active = controller;
      let timedOut = false;
      const timer = setTimeout(() => { timedOut = true; controller.abort(); }, 15000);
      try {
        const response = await fetch(`${path}/${endpoint}`, {
          method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify(body), signal: controller.signal, cache: 'no-store', credentials: 'same-origin', redirect: 'error'
        });
        if (!response.ok) throw new Error(response.status === 429 ? 'rate' : response.status === 422 ? 'selection' : 'connection');
        if (!/\bapplication\/json\b/i.test(response.headers.get('content-type') || '')) throw new Error('response');
        const result = await response.json();
        if (!result || typeof result !== 'object' || Array.isArray(result)) throw new Error('response');
        return result;
      } catch (error) { if (timedOut) throw new Error('timeout'); throw error; }
      finally { clearTimeout(timer); if (active === controller) active = undefined; }
    }
    function failure(error, version) {
      if (!current(version)) return;
      if (error.message === "selection") { message(document.documentElement.lang.startsWith("en") ? "Please select a single vehicle variant and original market." : "Bitte wähle eine eindeutige Fahrzeugvariante und den ursprünglichen Markt.", true); retry.hidden = !validPath; root.removeAttribute("aria-busy"); enableSelects(); return; }
      if (!current(version)) return;
      const messages = {
        config: tr("text_1nl1pn0"),
        rate: tr("text_15yt1fc"),
        timeout: tr("text_1fqe6ef"),
        response: tr("text_15uqndw")
      };
      message(messages[error.message] || tr("text_1tej9fb"), true);
      retry.hidden = !validPath; root.removeAttribute('aria-busy'); enableSelects();
    }
    async function loadOptions(seed) {
      invalidate(); lastAction = loadOptions; const version = revision, selected = seed&&keys.every(k=>typeof seed[k]==='string')?seed:criteria();
      message(tr("text_gb0ueo")); root.setAttribute('aria-busy', 'true'); selects.forEach(s => { s.disabled = true; });
      try {
        const result = await request('options', selected); if (!current(version)) return;
        if (!result.options || !keys.every(key => result.options[key] == null || (Array.isArray(result.options[key]) && result.options[key].length <= 10000 && result.options[key].every(v => text(v) && v.length > 0)))) throw new Error('response');
        selects.forEach((select, index) => {
          const values = [...new Set(result.options[keys[index]] || [])].filter(value => keys[index] !== 'series' || !hiddenSeries.has(value));
          select.replaceChildren(new Option(tr("text_ps4gkk"), ''), ...values.map(value => new Option(value, value)));
          select.value = selects.slice(0, index).every(s => s.value) && values.includes(selected[keys[index]]) ? selected[keys[index]] : '';
        });
        enableSelects(); root.removeAttribute('aria-busy');
        const next = selects.find(s => !s.value);
        message(selects[0].options.length < 2 ? tr("text_t796l8") : next?.options.length < 2 ? tr("text_2ay0a5") : tr("text_4yctn3"));
        if (selects.every(s => s.value)) await loadProfiles();
      } catch (error) { failure(error, version); }
    }
    function showProfiles(items) {
      if (!Array.isArray(items) || items.length > 1000 || !items.every(validProfile)) throw new Error('response');
      profiles.replaceChildren(); root.removeAttribute('aria-busy');
      if (!items.length) { message(tr("text_16604y")); return; }
      const groups = new Map();
      for (const profile of items) {
        const key = JSON.stringify([profile.series,profile.development_code,profile.model,profile.engine,profile.gearbox,profile.market ?? null]);
        if (!groups.has(key)) groups.set(key,{profile,keys:[]});
        groups.get(key).keys.push(profile.type_key);
      }
      if(restoringVehicle){
        const saved=restoringVehicle;restoringVehicle=null;
        const matches=[...groups.values()].filter(group=>['series','development_code','model','engine','gearbox','market'].every(k=>(group.profile[k]??null)===(saved.profile[k]??null))&&vehicleMemory?.identity([...new Set(group.keys)])===vehicleMemory.identity(saved.typeKeys));
        if(matches.length===1){loadOffers([...new Set(matches[0].keys)],matches[0].profile,{restored:true});return;}
      }
      message(document.documentElement.lang.startsWith("en") ? "Please select your transmission and original vehicle market." : "Bitte wähle Getriebe und ursprünglichen Fahrzeugmarkt.");
      for (const {profile,keys} of groups.values()) {
        const button = element('button', undefined, 'search-result'); button.type = 'button';
        const detail = element('span'); detail.append(element('strong', gearboxLabel(profile.gearbox)), element('small', [profile.development_code,profile.model,profile.engine,profile.market].filter(Boolean).join(' / ')));
        button.append(element('span', profile.development_code || 'BMW'), detail, element('span', '→'));
        on(button, 'click', () => loadOffers([...new Set(keys)],profile)); profiles.append(button);
      }
    }
    async function loadProfiles() {
      invalidate(); lastAction = loadProfiles; const version = revision;
      if (!selects.every(s => s.value)) { message(tr("text_pm0r4m")); return; }
      message(tr("text_gmb20w")); root.setAttribute('aria-busy','true');
      try { const result = await request('profiles', criteria()); if (current(version)) showProfiles(result.profiles); }
      catch (error) { failure(error, version); }
    }
    async function loadVin() {
      invalidate(); lastAction = loadVin; const version = revision;
      input.value = input.value.toUpperCase().replace(/\s/g, '');
      if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(input.value)) { input.setAttribute('aria-invalid','true'); message(tr("text_1rwfwes"), true); input.focus(); return; }
      input.removeAttribute('aria-invalid'); message(tr("text_4ykdos")); submit.disabled = true; root.setAttribute('aria-busy','true');
      try { const result = await request('vin', {vin: input.value}); if (current(version)) showProfiles(result.profiles); }
      catch (error) { failure(error, version); }
      finally { if (current(version)) submit.disabled = false; }
    }
    function moduleCard(offer, catalog, selection, version, source = 'api') {
      const master = catalog?.dataset.moduleKey === 'master' || moduleTitle(offer.title) === 'master';
      const card = element('article', undefined, `store-module q21-result-module${master ? ' store-master' : ''}`);
      card.setAttribute('data-offer-type', 'module');
      card.setAttribute('data-offer-source', source);
      const originalImage = catalog?.querySelector('img');
      if (originalImage) {
        const art = element('div', undefined, 'store-module-art'), image = element('img', undefined, 'q21-module-logo');
        art.setAttribute('aria-hidden', 'true');
        for (const [name, value] of Object.entries({src:originalImage.getAttribute('src'),alt:'',width:'64',height:'64',decoding:'async'})) image.setAttribute(name, value);
        art.append(image); card.append(art);
      }
      if (master) card.append(element('span', tr("text_9wvi7f"), 'store-master-label'));
      card.append(element('h4', (catalog?.dataset.productTitle || offer.title).replace(/^Module?\s*[-–—:]\s*/i, '')));
      const description = catalog?.querySelector('p')?.textContent || (document.documentElement.lang.startsWith('en') ? '' : offer.description) || '';
      if (description.length > 220) {
        const details = element('details', undefined, 'q21-module-description');
        details.append(element('summary', tr("text_1f3i1ib")), element('p', description)); card.append(details);
      } else if (description) card.append(element('p', description));
      const bottom = element('div', undefined, 'store-module-bottom');
      const price = catalog?.querySelector('strong')?.textContent;
      if (price) bottom.append(element('strong', price));
      bottom.append(element('span', tr("text_1jkx7xx")));
      const href = catalog?.querySelector('a')?.getAttribute('href');
      if (href && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9][a-z0-9-]*$/i.test(href)) {
        const link = element('a', tr("text_10h2hay"), 'button secondary'); link.setAttribute('href', href);
        link.setAttribute('aria-label', tr("text_1t7m1qy",{p0:offer.title})); bottom.append(link);
        if(productLayer){link.setAttribute('aria-haspopup','dialog');on(link,'click',event=>{event.preventDefault();if(current(version))productLayer.open({offer,...selection},link);});}
      }
      card.append(bottom);
      const availability = catalog?.querySelector('.store-binding-note')?.textContent;
      if (availability) card.append(element('span', availability, 'store-binding-note'));
      return card;
    }
    async function loadOffers(typeKeys, expectedProfile, options={}) {
      invalidate(); lastAction = () => loadOffers(typeKeys, expectedProfile, options); const version = revision;
      message(tr("text_3vcalb")); root.setAttribute('aria-busy','true');
      try {
        if (!typeKeys.length || typeKeys.length > 200 || !typeKeys.every(validKey)) throw new Error('response');
        const result = await request('offers', {type_keys: typeKeys}); if (!current(version)) return;
        if (!result.profile || !['series','development_code','model','engine','gearbox','market'].every(k => result.profile[k] === expectedProfile[k]) || !(typeKeys.length === 1 ? result.profile.type_key === typeKeys[0] : result.profile.type_key === null) || !Array.isArray(result.offers) || result.offers.length > 100 || !result.offers.every(o => o && text(o.title) && o.title.trim() && (o.description == null || text(o.description,6000)))) throw new Error('response');
        $('[data-vehicle]').textContent = label(result.profile);
        const target = $('[data-offers]');
        const selection = {profile:{...result.profile,type_keys:typeKeys},vin:method==='vin'?input.value:'',relatedOffers:result.offers.map(offer=>({title:offer.title}))};
        const licenses = [], modules = [];
        for (const offer of result.offers) {
          const catalog = moduleCatalog.get(moduleTitle(offer.title));
          if (catalog || /^module?\s*[-–—:]/i.test(offer.title)) modules.push({offer, catalog, source:'api'});
          else licenses.push(offer);
        }
        // Modules do not require an ECU/TCU offer. Only supplement a valid, confirmed
        // vehicle response with real Shopify products; preserve API details and deduplicate.
        const remaining = new Map(modules.map(entry => [moduleTitle(entry.offer.title), entry]));
        modules.length = 0;
        for (const [title, catalog] of moduleCatalog) {
          if (!catalog) continue;
          modules.push(remaining.get(title) || {offer:{title:catalog.dataset.productCanonicalTitle || catalog.dataset.productTitle},catalog,source:'catalog'});
          remaining.delete(title);
        }
        modules.push(...remaining.values());
        // The add-on is a real Shopify product, offered only alongside a confirmed ECU OTS result.
        // This is not a new compatibility decision; the backend still owns the vehicle approval.
        const customTune=productLayer?.find?.({title:'ECU - Custom Tune'});
        if(customTune && licenses.some(item=>/^ECU\s*[-–—]\s*.+[-–—]\s*OTS$/i.test(item.title.trim())) && !licenses.some(item=>/^ECU\s*[-–—]\s*Custom Tune$/i.test(item.title.trim()))) {
          licenses.push({title:'ECU - Custom Tune'});
        }
        for (const offer of licenses) {
          const article = element('article', undefined, 'q21-backend-offer');
          article.setAttribute('data-offer-type', 'license');
          if (licenses.length === 1) article.setAttribute('data-single-license', 'true');
          article.append(element('span',tr("text_3pzuzs"),'eyebrow'),element('h3',productLayer?.find?.(offer)?.title || offer.title));
          if(offer.description && !document.documentElement.lang.startsWith('en'))article.append(element('p',offer.description));
          const product=productLayer?.find?.(offer);
          article.dataset.offerKind=product?.group==='custom'?'custom':/\bOTS\b/i.test(offer.title)?'ots':/Single Option/i.test(offer.title)?'single':/^TCU\b/i.test(offer.title)?'tcu':'other';
          if(article.dataset.offerKind==='ots'){
            const included=element('p',undefined,'q21-offer-includes');
            included.append(element('strong',english?'Everything in one OTS licence':'Alles in einer OTS-Lizenz'),element('small',english?'ECU update · Stock · Stage 1 · Stage 2 · Single Options':'ECU-Update · Original · Stage 1 · Stage 2 · Single Options'));article.append(included);
          }
          if(article.dataset.offerKind==='single')article.append(element('p',english?'ECU update, stock software and released Single Options. No Stage 1 or Stage 2.':'ECU-Update, Originalsoftware und freigegebene Single Options. Ohne Stage 1 und Stage 2.','q21-single-offer-note'));
          if(article.dataset.offerKind==='tcu')article.append(element('p',english?'Automatic transmission tuning. Software calibration for your vehicle’s automatic gearbox.':'Automatikgetriebe-Tuning. Softwareabstimmung für das Automatikgetriebe deines Fahrzeugs.','q21-tcu-offer-note'));
          if(product?.group==='custom')article.append(element('p',document.documentElement.lang.startsWith('en')?'Individual calibration for modified hardware. Add-on to a compatible OTS licence. Full modification details are required; an old order number is optional.':'Individuelle Abstimmung bei geänderter Hardware. Add-on zu einer passenden OTS-Lizenz. Alle Umbauten sind anzugeben; eine alte Bestellnummer ist freiwillig.','q21-custom-offer-note'));
          if(product?.priceLabel){
            const price=element('div',undefined,'q21-offer-price');
            price.append(element('strong',`${product.priceVaries?tr("text_pbsme6"):''}${product.priceLabel}`),element('span',tr("text_1jkx7xx")));
            article.append(price);
          }
          if(productLayer){
            const trigger=element('button',tr("text_15a6rqi"),'q21-offer-trigger');trigger.type='button';trigger.setAttribute('aria-haspopup','dialog');trigger.setAttribute('aria-label',tr("text_6x5gdx",{p0:offer.title}));
            if(article.dataset.offerKind==='ots')trigger.textContent=english?'Select OTS':'OTS auswählen';
            on(trigger,'click',()=>{if(current(version))productLayer.open({offer,...selection},trigger);});article.append(trigger);
          }else article.append(element('small',tr("text_h5snuc")));
          target.append(article);
        }
        if (!licenses.length && modules.length) {
          const notice = element('div', undefined, 'q21-empty-offers');
          notice.append(element('span',tr("text_uzxy2u"),'eyebrow'),element('h3',tr("text_1cldc5y")),element('p',tr("text_14cr3jq")));
          target.append(notice);
        }
        if (modules.length) {
          const group = element('section', undefined, 'q21-result-modules');
          group.setAttribute('aria-label', tr("text_i3z7pp"));
          const heading = element('div', undefined, 'q21-result-modules-heading');
          heading.append(element('h3', tr("text_1tqf4b7")), element('p', tr("text_13oq3j7")));
          const grid = element('div', undefined, 'store-module-grid');
          for (const {offer, catalog, source} of modules) if (!/pa2tm|kundenübernahme|kundenuebernahme|customer takeover/i.test(offer.title || "")) grid.append(moduleCard(offer,catalog,selection,version,source));
          group.append(heading, grid, element('p', tr("text_1w50rrj"), 'q21-result-modules-note'));
          target.append(group);
        }
        if (!licenses.length && !modules.length) {
          const empty = element('div', undefined, 'q21-empty-offers');
          empty.append(element('span',tr("text_uzxy2u"),'eyebrow'),element('h3',tr("text_1ptl6nn")),element('p',tr("text_1usqmzp")));
          target.append(empty);
        }
        panel.hidden = false; decorateOfferUi(target); root.removeAttribute('aria-busy'); message(tr("text_ci6pf3"));
        vehicleMemory?.write({profile:result.profile,typeKeys,vin:selection.vin});
        window.Q21StoreMotion?.refresh?.();
        const performanceShown=performanceAction('show',{offers:licenses,profile:result.profile,typeKeys,performance:result.performance})===true;
        if(options.restored){ /* Restore without jumping the customer's scroll position. */ }
        else if(mobile.matches){ panel.focus({preventScroll:true}); panel.scrollIntoView({block:'start',behavior:'auto'}); }
        else if(performanceShown){
          const slot=$('[data-q21-performance-slot]');
          slot.closest('.q21-config-section')?.focus({preventScroll:true});
          slot.scrollIntoView({block:'start',behavior:'auto'});
        } else { panel.focus({preventScroll:true}); panel.scrollIntoView({block:'start',behavior:'auto'}); }
      } catch (error) { failure(error, version); }
    }
    // Same segmented-control gesture as the guide, scoped to the two finder methods.
    // Selection delegates to tab(), keeping invalidation, VIN clearing and API logic intact.
    function bindFinderMethodSwipe(buttons, choose) {
      const nav=buttons[0]?.parentElement;
      if(!nav||buttons.length!==2)return null;
      const options={signal:events.signal};
      const enabled=window.matchMedia('(max-width:700px), (hover:none) and (pointer:coarse)');
      const thumb=element('span',undefined,'q21-method-thumb');
      thumb.setAttribute('aria-hidden','true');nav.prepend(thumb);
      nav.setAttribute('data-method-swipe-ready','1.0.0');
      let drag=null,suppressClick=false;
      const clamp=(value,min,max)=>Math.max(min,Math.min(max,value));
      function place(left,width){
        nav.style.setProperty('--method-thumb-x',left+'px');
        nav.style.setProperty('--method-thumb-width',width+'px');
      }
      function sync(){
        const selected=buttons.find(button=>button.getAttribute('aria-selected')==='true');
        if(!selected||!nav.getClientRects().length)return;
        place(selected.offsetLeft,selected.offsetWidth);
      }
      function finish(cancelled){
        if(!drag)return;
        const ending=drag;drag=null;nav.removeAttribute('data-method-dragging');
        if(ending.horizontal&&!cancelled){
          const pitch=buttons[1].offsetLeft-buttons[0].offsetLeft;
          let index=pitch>0?Math.round((ending.left-buttons[0].offsetLeft)/pitch):ending.index;
          if(index===ending.index&&Math.abs(ending.dx)>=Math.min(30,pitch*.3))index+=Math.sign(ending.dx);
          index=clamp(index,0,1);
          if(index!==ending.index)choose(buttons[index].dataset.method);
          buttons[index].focus({preventScroll:true});suppressClick=true;
        }
        if(nav.hasPointerCapture?.(ending.id))nav.releasePointerCapture(ending.id);
        sync();
      }
      nav.addEventListener('pointerdown',event=>{
        suppressClick=false;
        if(!enabled.matches||event.isPrimary===false||event.button!==0||drag)return;
        const index=Math.max(0,buttons.findIndex(button=>button.getAttribute('aria-selected')==='true'));
        drag={id:event.pointerId,x:event.clientX,y:event.clientY,index,origin:buttons[index].offsetLeft,left:buttons[index].offsetLeft,dx:0,horizontal:false};
      },{...options,passive:true});
      nav.addEventListener('pointermove',event=>{
        if(!drag||event.pointerId!==drag.id)return;
        const dx=event.clientX-drag.x,dy=event.clientY-drag.y;
        if(!drag.horizontal){
          if(Math.abs(dy)>8&&Math.abs(dy)>Math.abs(dx)){finish(true);return;}
          if(Math.abs(dx)<10||Math.abs(dx)<Math.abs(dy)*1.2)return;
          drag.horizontal=true;nav.setAttribute('data-method-dragging','');
          // Preserve the touch/pen button's native implicit capture (iOS included).
          if(event.pointerType!=='touch'&&event.pointerType!=='pen')nav.setPointerCapture(event.pointerId);
        }
        event.preventDefault();drag.dx=dx;
        drag.left=clamp(drag.origin+dx,buttons[0].offsetLeft,buttons[1].offsetLeft);
        const pitch=buttons[1].offsetLeft-buttons[0].offsetLeft;
        const progress=pitch>0?(drag.left-buttons[0].offsetLeft)/pitch:0;
        place(drag.left,buttons[0].offsetWidth+(buttons[1].offsetWidth-buttons[0].offsetWidth)*progress);
      },{...options,passive:false});
      nav.addEventListener('pointerup',event=>{
        if(!drag||event.pointerId!==drag.id)return;
        if(drag.horizontal)event.preventDefault();finish(false);
      },options);
      nav.addEventListener('pointercancel',event=>{if(event.pointerId===drag?.id)finish(true);},options);
      nav.addEventListener('lostpointercapture',event=>{if(event.target===nav&&event.pointerId===drag?.id)finish(true);},options);
      nav.addEventListener('click',event=>{
        if(!suppressClick)return;
        suppressClick=false;event.preventDefault();event.stopPropagation();
      },{...options,capture:true});
      const resized=()=>{finish(true);sync();};
      const observer='ResizeObserver' in window?new ResizeObserver(resized):null;
      observer?.observe(nav);
      if(!observer)window.addEventListener('resize',resized,{...options,passive:true});
      enabled.addEventListener('change',resized,options);sync();
      return {sync,dispose(){
        finish(true);observer?.disconnect();thumb.remove();
        nav.removeAttribute('data-method-swipe-ready');nav.removeAttribute('data-method-dragging');
        nav.style.removeProperty('--method-thumb-x');nav.style.removeProperty('--method-thumb-width');
      }};
    }

    function tab(name) {
      invalidate(); method = name; clearVin(); message('');
      root.querySelectorAll('[data-method]').forEach(button => { const selected = button.dataset.method === name; button.setAttribute('aria-selected', String(selected)); button.tabIndex = selected ? 0 : -1; });
      root.querySelectorAll('[data-panel]').forEach(p => { p.hidden = p.dataset.panel !== name; });
      methodSwipe?.sync();
      if (name === 'car') loadOptions(); else { lastAction = loadVin; message(tr("text_9zp7e5")); }
    }
    selects.forEach((select,index) => on(select,'change',() => { restoringVehicle=null; invalidate(); clearAfter(index); if (index === keys.length - 1 && select.value) loadProfiles(); else loadOptions(); }));
    on(input,'input',() => { restoringVehicle=null; invalidate(); input.value = input.value.toUpperCase().replace(/\s/g,''); input.removeAttribute('aria-invalid'); $('[data-vin-count]').textContent = `${input.value.length} / 17`; message(''); });
    on($('[data-vin-form]'),'submit',event => { event.preventDefault(); loadVin(); });
    root.querySelectorAll('[data-method]').forEach(button => {
      on(button,'click',() => {restoringVehicle=null;tab(button.dataset.method);});
      on(button,'keydown',event => { if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return; event.preventDefault(); restoringVehicle=null; const name = event.key === 'Home' ? 'car' : event.key === 'End' ? 'vin' : method === 'car' ? 'vin' : 'car'; tab(name); $(`[data-method="${name}"]`).focus(); });
    });
    on(retry,'click',() => { if (lastAction) lastAction(); });
    function forgetVehicle(){restoringVehicle=null;selects[0].value='';clearAfter(0);clearVin();tab(method);}
    on($('[data-reset]'),'click',() => {if(vehicleMemory)vehicleMemory.clear();else forgetVehicle();});
    const unsubscribeVehicle=vehicleMemory?.subscribe((selection,source)=>{if(source==='clear'){forgetVehicle();}else if(source==='storage'){restoringVehicle=null;invalidate();if(selection)restoreVehicle(selection);else forgetVehicle();}});
    on($('[data-change-vehicle]'),'click',() => { restoringVehicle=null; tab(method); $('#finder').scrollIntoView({block:'start',behavior:'auto'}); $(`[data-method="${method}"]`).focus({preventScroll:true}); });
    const methodSwipe=bindFinderMethodSwipe([...root.querySelectorAll('[data-method]')],tab);
    instances.set(root,() => { unsubscribeVehicle?.(); methodSwipe?.dispose(); disposed = true; revision++; active?.abort(); events.abort(); performanceAction('destroy'); productLayer?.dispose(); clearVin(); });
    function restoreVehicle(saved){
      if(!saved||!validPath){loadOptions();return;}
      restoringVehicle=saved;
      if(saved.vin){tab('vin');restoringVehicle=saved;input.value=saved.vin;$('[data-vin-count]').textContent='17 / 17';loadVin();}
      else loadOptions(saved.criteria);
    }
    input.disabled = !validPath; submit.disabled = !validPath;
    restoreVehicle(vehicleMemory?.read());
  }
  function scan(scope) { if (scope.matches?.('[data-q21-finder]')) mount(scope); scope.querySelectorAll?.('[data-q21-finder]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => scan(document),{signal:lifecycle.signal,once:true}); else scan(document);
  document.addEventListener('shopify:section:load',event => scan(event.target),{signal:lifecycle.signal});
  document.addEventListener('shopify:section:unload',event => { for (const [root,dispose] of instances) if (event.target === root || event.target.contains(root)) { dispose(); instances.delete(root); } },{signal:lifecycle.signal});
  window.Q21BackendFinder = {dispose() { lifecycle.abort(); for (const dispose of instances.values()) dispose(); instances.clear(); }};
})();
